import { render, staticRenderFns } from "./SupportRequest.vue?vue&type=template&id=02a019b5&"
import script from "./SupportRequest.vue?vue&type=script&lang=js&"
export * from "./SupportRequest.vue?vue&type=script&lang=js&"
import style0 from "./SupportRequest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports